import script from "./TreeSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./TreeSelect.vue?vue&type=script&lang=ts&setup=true"

import "./TreeSelect.vue?vue&type=style&index=0&id=0c1fb439&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c1fb439"]])

export default __exports__